import * as api from "../../shared/api";
import * as biz_data_helper from "../../shared/biz_data_helper";

const content_type = "sPlant_SpoilageTypeRatio";

const create = function () {
  return {
    content_type: "muji",
    age: 29
  };
};
const descriptor = {};

const biz_data = new biz_data_helper.base_entity_helper(
  content_type,
  create,
  descriptor
);

const fields = {
  default: [
    {
      key: "id",
      label: "编号",
      sortable: true,
      type: "button",
      button: {
        type: "text"
      },
      thStyle: { width: "60px" }
    },
    // { key: 'dataAreaId', label: '公司', sortable: true },
    { key: 'SpoilageType', label: '加放类型', sortable: true },
    { key: 'Ratio', label: '系数', sortable: true },
    { key: 'carryType', label: '进位方式', sortable: true },
  ]
};

const dataForm = {};

///前端验证
const rules = {};
const methods = {
  ///get
  async getData(_params) {
    let result = await biz_data
      .selectAction({
        params: _params,
        fields: _.map(fields.default, "key")
      })
      .run();

    if (
      result &&
      result[0].result &&
      result[0].result.data &&
      result[0].result.data.ActionResult &&
      result[0].result.data.ActionResult.Result &&
      result[0].result.data.ActionResult.Result.Data.length > 0
    ) {
      return result[0].result.data.ActionResult.Result.Data;
    } else {
      return null;
    }
  },
  async saveData(params) {
    let _actions = [];
    for (var k in params) {
      if (k == "add") {
        _actions.push(
          biz_data.insertAction({
            params: params[k],
            fields: _.map(fields.default, "key")
          }).action({})
        );
      }
      else if (k == "edit") {
        _actions.push(
          biz_data.updateAction({
            params: params[k],
            fields: _.map(fields.default, "key")
          }).action({})
        );
      }
      else if (k == "delete") {
        _actions.push(
          biz_data.deleteAction({
            params: params[k],
            fields: _.map(fields.default, "key")
          }).action({})
        );
      }
    }
    let result = await api.query_batch({
      actions: _actions
    });
    if (
      result &&
      result.data &&
      result.data.BatchResult &&
      result.data.BatchResult.Actions &&
      result.data.BatchResult.Actions.length > 0 &&
      result.data.BatchResult.Actions[0].Result.Data.length > 0
    ) {
      return result.data.BatchResult.Actions[0].Result.Data[0];
    } else {
      return null;
    }
  }
};
export { biz_data, dataForm, fields, methods, rules };

